import React, { Component } from 'react'
import ReactDOM from 'react-dom';
import { withRouter } from 'react-router-dom';
import './AttackGame.css';

import backgroundImage from '../assets/images/attack-game/bg.png';

import yellowDrone from '../assets/images/attack-game/drone-yellow.png';
import redDrone from '../assets/images/attack-game/drone-red.png';
import blueDrone from '../assets/images/attack-game/drone-blue.png';

import topBar from '../assets/images/attack-game/top-bar.png'
import controllerImage from '../assets/images/attack-game/controller.png'
import arrowUpImage from '../assets/images/attack-game/arrow-up.png'
import arrowDownImage from '../assets/images/attack-game/arrow-down.png'
import batteryImage from '../assets/images/attack-game/battery.png'
import bombImage from '../assets/images/attack-game/bomb.png'
import addTen from '../assets/images/attack-game/add-10.png'
import removeOne from '../assets/images/attack-game/remove-1.png'
import removeTen from '../assets/images/attack-game/remove-10.png'

import btnBullet from '../assets/images/attack-game/btn-bullet.png';
import interferenceElimination from '../assets/images/attack-game/interference-elimination.png';

import gameOverTimeout from '../assets/images/attack-game/drone-timeout.png'
import gameOverBroken from '../assets/images/attack-game/drone-broken.png'

const drones = [ yellowDrone, redDrone, blueDrone ]

const OBJECT_SPLITTER = [ 0.0, 1.0, 0.0 ]
const FADE_OUT_SPACING = 0.35;
const OPACITY_INTERVAL = 500;

function createRandomNumber(min, max) {
    return Math.random() * (max - min) + min;
}

class AttackGame extends Component {

    btnSound = './sounds/button_sound.mp3';
    arrowBtnSound = './sounds/arrow_btn.mp3';
    collisionSound = './sounds/collision.mp3';
    birdAttackSound = './sounds/bird_attack.mp3';
    bulletSound = './sounds/bullet.mp3';

    maxHeight = 10;
    minHeight = 70;
    countdownInterval = null;
    bombInterval = null;
    addTenInterval = null;
    removeTenInterval = null;
    removeOneInterval = null;

    bullets = []
    
    constructor(props) {
        super(props);
        this.state = {
            droneImage: drones[this.props.location.state.selectedIndex],
            countdown: 60,
            battery: 3,
            playing: false,
            bombOpacity: 0.0,
            score: 100,
            playerVerticalPosition: 0,
            gameOverTimeout: false,
            gameOverBroken: false,
            addTenOpacity: 0.0,
            removeTenOpacity: 0.0,
            removeOneOpacity: 0.0,
            objects: [],
            eagleHit: false,
            bombEnabled: false
        };

        this.domRefs = {}; // to store dom refs
        this.animateElements = this.animateElements.bind(this);
        setTimeout(() => {
            this.startAttack();
            setInterval(() => {
                if (this.state.playing) {
                    this.startAttack();
                }
            }, 7.5 * 1000);
        }, 1000);
    }

    animateElements() {
        if (this.state.playing === true) {
            let playerRect = this.getBounds(this.refs.player);
            let eagleRect = this.getBounds(this.refs.eagle);
            if (playerRect != null) {
                this.bullets.forEach((bullet) => {
                    if (bullet.className !== 'bullet-hit') {
                        if (this.detectCollision(this.getElementBounds(bullet), eagleRect)) {
                            this.setState({
                                eagleHit: true, 
                                score: this.state.score + 10,
                            });
                            this.startAddTen();
                            bullet.className = 'bullet-hit';
                            setTimeout(() => {
                                this.setState({
                                    eagleHit: false
                                });
                            }, 1.2 * 1000);
                        }
                    }
                });
                if (!this.state.bombEnabled) {
                    if (this.detectObjectCollision(eagleRect, playerRect)) {
                        console.log('bomb');
                        this.setState({
                            battery: this.state.battery - 1,
                            score: this.state.score - 10,
                            bombOpacity: 1.0,
                            bombEnabled: true
                        });
                        this.startRemoveOne();
                        this.startRemoveTen();
                        this.playCollisionBtnSound();
                        this.startBomb();
                        this.checkBatteryToGameOver();
                    }
                }
            }
        }
        requestAnimationFrame(this.animateElements);
    }

    startAttack() {
        let randomTime = createRandomNumber(1000, 2500);
        let interval = setTimeout(() => {
            this.playBirdAttackSound();
            let eagle = ReactDOM.findDOMNode(this.refs.eagle);
            let eagleRect = this.getBounds(this.refs.eagle);
            let playerRect = this.getBounds(this.refs.player);
            if (eagle !== null) {
                eagle.animate([
                        { transform: 'translate(0px, 0px)' },
                        { transform: 'translate(' + (playerRect.x - eagleRect.x + (playerRect.width / 2)) + 'px, ' + (playerRect.y - eagleRect.y) + 'px)' },
                        { transform: 'translate(0px, 0px)' }
                    ], {
                    duration: 6000,
                    iterations: 1,
                    fillMode: 'forward'
                }).onfinish = function(e) {
                    this.cancel();
                };
            }
            clearInterval(interval);
        }, randomTime);
    }

    startAddTen() {
        if (this.addTenInterval !== null) {
            clearInterval(this.addTenInterval);
        }
        if (this.removeTenInterval !== null) {
            clearInterval(this.removeTenInterval);
            this.setState({
                removeTenOpacity: 0.0
            })
        }
        this.setState({
            addTenOpacity: 1.0
        });
        this.addTenInterval = setInterval(() => {
            if (this.state.addTenOpacity >= 0) {
                this.setState({
                    addTenOpacity: this.state.addTenOpacity - FADE_OUT_SPACING
                })
            } else {
                clearInterval(this.addTenInterval)
                this.addTenInterval = null
            }
        }, OPACITY_INTERVAL);
    }

    startRemoveTen() {
        if (this.addTenInterval !== null) {
            clearInterval(this.addTenInterval);
            this.setState({
                addTenOpacity: 0.0
            });
        }
        if (this.removeTenInterval !== null) {
            clearInterval(this.removeTenInterval);
        }
        this.setState({
            removeTenOpacity: 1.0
        });
        this.removeTenInterval = setInterval(() => {
            if (this.state.removeTenOpacity >= 0) {
                this.setState({
                    removeTenOpacity: this.state.removeTenOpacity - FADE_OUT_SPACING
                })
            } else {
                clearInterval(this.removeTenInterval)
                this.removeTenInterval = null
            }
        }, OPACITY_INTERVAL);
    }

    startRemoveOne() {
        if (this.addOneInterval !== null) {
            clearInterval(this.addOneInterval);
        }
        this.setState({
            removeOneOpacity: 1.0
        });
        this.addOneInterval = setInterval(() => {
            if (this.state.removeOneOpacity >= 0) {
                this.setState({
                    removeOneOpacity: this.state.removeOneOpacity - FADE_OUT_SPACING
                })
            } else {
                clearInterval(this.addOneInterval)
                this.addOneInterval = null
            }
        }, OPACITY_INTERVAL);
    }

    startBomb() {
        this.setState({
            bombEnabled: true
        });
        if (this.bombInterval !== null) {
            clearInterval(this.bombInterval);
        }
        this.bombInterval = setInterval(() => {
            if (this.state.bombOpacity >= 0) {
                this.setState({
                    bombOpacity: this.state.bombOpacity - FADE_OUT_SPACING
                })
            } else {
                clearInterval(this.bombInterval)
                this.setState({
                    bombOpacity: 0.0,
                    bombEnabled: false
                });
            }
        }, OPACITY_INTERVAL);
    }

    checkBatteryToGameOver() {
        if (this.state.battery <= 0) {
            this.setState({
                gameOverBroken: true
            });
            this.gameOver();
        }
    }

    getBounds(ref) {
        let element = ReactDOM.findDOMNode(ref);
        return (element === null || element === undefined) ? null : ReactDOM.findDOMNode(ref).getBoundingClientRect();
    }

    getElementBounds(element) {
        return (element === null || element === undefined) ? null : element.getBoundingClientRect();
    }

    detectCollision(a, b) {
        if (a === null || b === null) return false;
        return !(
            ((a.y + a.height) < (b.y)) ||
            (a.y > (b.y + b.height)) ||
            ((a.x + a.width) < b.x) ||
            (a.x > (b.x + b.width))
        );
    }

    detectObjectCollision(a, b) {
        if (a === null || b === null) return false;
        const elementWidth = b.width / OBJECT_SPLITTER.length;
        for (let i = 0; i < OBJECT_SPLITTER.length; i++) {
            if (OBJECT_SPLITTER[i] > 0) {
                let elementHeight = b.height * OBJECT_SPLITTER[i];
                let element = {
                    x: b.x + (elementWidth * i),
                    y: b.y + (b.height - elementHeight) / 2,
                    width: elementWidth,
                    height: elementHeight
                }
                if (this.detectCollision(a, element)) {
                    return true;
                }
            }
        }
        return false;
    }

    gameOver() {
        this.setState({
            playing: false
        });
        setTimeout(() => {
            this.props.history.push({
                pathname: './score',
                state: {
                    score: this.state.score < 0 ? 0 : this.state.score,
                    selectedIndex: this.props.location.state.selectedIndex,
                }
            });
        }, 1000 * 1.5);
    }

    componentDidMount() {
        window.addEventListener('keypress', this.keyPress);
        let starting = setInterval(() => {
            let x = this.state.playerVerticalPosition;
            if (x >= 50) {
                clearInterval(starting);
                this.setState({ playing : true }) 
                requestAnimationFrame(this.animateElements)
            } else {
                this.setState({
                    playerVerticalPosition: x + 1
                });
            }
        }, 10);
        this.countdownInterval = setInterval(() => {
            if (this.state.countdown === 0) {
                this.setState({
                    gameOverTimeout: true
                });
                this.gameOver();
            } else {
                this.setState({
                    countdown: this.state.countdown - 1
                });
            }
        }, 1 * 1000);
    }

    componentWillUnmount() {
        this.setState({ playing : false }) 
        window.removeEventListener('keypress', this.keyPress);
        cancelAnimationFrame(this.animateElements)
        clearInterval(this.countdownInterval);  
    }

    keyPress = (event) => {
        if (event.key === 'w') {
            (event).preventDefault();
            this.goUp();
        } else if (event.key === 's') {
            (event).preventDefault();
            this.goDown();
        }
    };

    goUp() {
        if (this.state.playing === true) {
            this.playArrowBtnSound();
            let position = this.state.playerVerticalPosition;
            if (position >= this.maxHeight) {
                this.setState({
                    playerVerticalPosition: position - 2
                });
            }
        }
    }

    goDown() {
        if (this.state.playing === true) {
            this.playArrowBtnSound();
            let position = this.state.playerVerticalPosition;
            if (position <= this.minHeight) {
                this.setState({
                    playerVerticalPosition: position + 2
                });
            }
        }
    }

    shootBullet() {
        this.playBulletSound();
        let container = document.getElementById('bullet-container');
        let div = document.createElement('div');
        div.className = 'test';
        div.style.top = (this.state.playerVerticalPosition + 9) + '%'
        this.bullets.push(div);
        container.appendChild(div);
    }

    playArrowBtnSound() {
        //this.playAudio(this.arrowBtnSound);
    }

    playCollisionBtnSound() {
        this.playAudio(this.collisionSound);
    }

    playBirdAttackSound() {
        this.playAudio(this.birdAttackSound);
    }

    playBulletSound() {
        this.playAudio(this.bulletSound);
    }

    playAudio(filePath) {
        try {
            let btnAudio = new Audio(filePath);
            btnAudio.play();
        } catch (exception) {
            console.log(exception.message);
        }
    }

    render() {
        return (
            <div className='page-root-div' style={{ position: 'fixed', overflow: 'hidden' }}>
                <img alt='' src={backgroundImage} style={{ width: '100%', height: '100%', overflow: 'hidden', objectFit: 'cover', position: 'absolute' }}/>
                <div className='drone-player' ref='player' style={{ position: 'absolute', width: '16.7%', height: '16.9%', left: '10%', top: this.state.playerVerticalPosition + '%' }}>
                    <img alt='' src={this.state.droneImage} style={{ position: 'absolute', width: '100%', height: '100%', zIndex: '10', objectFit: 'scale-down' }}></img>
                    <img alt='' src={bombImage} style={{ position: 'absolute', width: '80%', height: '80%', zIndex: '11', objectFit: 'scale-down', opacity: this.state.bombOpacity, right: '0px', bottom: '0px' }}></img>
                </div>
                <div className={ this.state.eagleHit ? 'block-item hit' : 'block-item' } ref='eagle' style={{ posistion: 'absolute', width: '17.7%', height: '18.5%', left: '52%', top: '40%' }}>
                    <div></div>
                </div>
                <div className='bullet-div' ref='bullet' id='bullet-container'></div>
                <div style={{ position: 'absolute', width: '29%', height: '50%', right: '0px', bottom: '0px', zIndex: '1' }}>
                    <img alt='' src={controllerImage} style={{ position: 'absolute', width: '100%' }}></img>
                    <img alt='' className='press-btn' src={arrowUpImage} style={{ position: 'absolute', width: '20%', left: '27%', top: '45%' }} onClick={this.goUp.bind(this)}></img>
                    <img alt='' className='press-btn' src={arrowDownImage} style={{ position: 'absolute', width: '20%', left: '29%', top: '62%' }} onClick={this.goDown.bind(this)}></img>
                    <img alt='' className='press-btn' src={btnBullet} style={{ position: 'absolute', width: '36%', right: '8%', top: '44%' }} onClick={this.shootBullet.bind(this)}></img>
                </div>
                <div style={{ position: 'absolute', left: '0px', top: '3%', height: '10%', width: '100%' }}>
                    <img alt='' src={topBar} style={{ position: 'absolute', height: '100%', left: '50%', transform: 'translate(-50%, 0px)' }}></img>
                    <div style={{ position: 'absolute', right: '42%', top: '30%', width: '6%', height: '50%', color: '#086940' }}>
                        <svg width='100%' height='100%' viewBox='0 0 500 75' preserveAspectRatio="xMinYMid meet" style={{ position: 'absolute' }} xmlns="http://www.w3.org/2000/svg" xmlnsXlink='http://www.w3.org/1999/xlink'>
                            <text x="50%" y ="50%" dominantBaseline="middle" textAnchor="middle" fontSize="200" fill="#086940" >{this.state.countdown}</text>
                        </svg>
                    </div>
                    <div style={{ position: 'absolute', right: '4%', top: '30%', width: '6%', height: '50%', color: 'white' }}>
                        <svg width='100%' height='100%' viewBox='0 0 500 75' preserveAspectRatio="xMinYMid meet" style={{ position: 'absolute' }} xmlns="http://www.w3.org/2000/svg" xmlnsXlink='http://www.w3.org/1999/xlink'>
                            <text x="50%" y ="50%" dominantBaseline="middle" textAnchor="middle" fontSize="200" fill="white" >{this.state.score}</text>
                        </svg>
                    </div>
                    <img alt='' src={batteryImage} style={{ position: 'absolute', width: '2.5%', left: '20%', top: '18%', display: this.state.battery > 2 ? 'block' : 'none' }}></img>
                    <img alt='' src={batteryImage} style={{ position: 'absolute', width: '2.5%', left: '17%', top: '18%', display: this.state.battery > 1 ? 'block' : 'none' }}></img>
                    <img alt='' src={batteryImage} style={{ position: 'absolute', width: '2.5%', left: '14%', top: '18%', display: this.state.battery > 0 ? 'block' : 'none' }}></img>
                </div>
                <img alt='' src={addTen} style={{ position: 'absolute', width: '14%', top: '12%', right: '2%', opacity: this.state.addTenOpacity }}></img>
                <img alt='' src={removeTen} style={{ position: 'absolute', width: '14%', top: '12%', right: '2%', opacity: this.state.removeTenOpacity }}></img>
                <img alt='' src={removeOne} style={{ position: 'absolute', width: '14%', top: '10%', left: '10%', opacity: this.state.removeOneOpacity }}></img>
                {
                    this.state.gameOverBroken && <img alt='' src={gameOverBroken} style={{ width: '40%', left: '30%', top: '25%', position: 'absolute' }}></img>
                }
                {
                    this.state.gameOverTimeout && <img alt='' src={gameOverTimeout} style={{ width: '40%', left: '30%', top: '25%', position: 'absolute' }}></img>
                }
            </div>
        );
    }
}

export default withRouter(AttackGame);
